import React from "react";
import SearchOptions from "../../PriceOfferComponent/SearchOptions/SearchOptions";
import "./SearchTypeBlock.css";

/**
 * SearchTypeBlock - Block for selecting search type (tabs)
 * 
 * Displays the search type selector tabs (Packages, Hotels, etc.)
 * This is a wrapper around the existing SearchOptions component
 */
const SearchTypeBlock = () => {
  return (
    <div className="search-type-block-wrapper">
      <SearchOptions />
    </div>
  );
};

export default SearchTypeBlock;

